import Component from './survey-card-skeleton';

export default Component;
